import { configure, defineRule, Form, Field, ErrorMessage } from 'vee-validate'
import { required, email, min, max, regex } from '@vee-validate/rules'

// Đăng ký các rules cơ bản
defineRule('required', required)
defineRule('email', email)
defineRule('min', min)
defineRule('max', max)
defineRule('regex', regex)

// Đăng ký rules tùy chỉnh
defineRule('login_id', (value) => {
  if (!value) return 'ログインIDを入力してください。'
  return true
})

defineRule('password', (value) => {
  if (!value) return 'パスワードを入力してください。'
  return true
})

const veeValidatePlugin = {
  install: (app) => {
    // Đăng ký các components toàn cục
    app.component('VeeForm', Form)
    app.component('VeeField', Field)
    app.component('VeeErrorMessage', ErrorMessage)

    // Cấu hình vee-validate
    configure({
      validateOnBlur: true,
      validateOnChange: true,
      validateOnInput: true,
      validateOnModelUpdate: true,
      generateMessage: (context) => {
        const { field, rule } = context
        const messages = {
          required: () => `${field}を入力してください。`,
          email: () => `正しいメールアドレスの書式で入力してください`,
          min: (ctx) => `${field}は${ctx.rule.params[0]}文字以上で入力してください。`,
          max: (ctx) => `${field}は${ctx.rule.params[0]}字以内で入力してください。`,
          alpha_dash: () => `${field}は半角英数字、-(ハイフン)、_(アンダーバー)で入力してください。`,
          date_format: () => `${field}を正しい書式で入力してください。`,
          _default: () => `${field}の値が正しくありません。`
        }

        return messages[rule?.name || '_default']?.(context) || messages._default()
      }
    })
  }
}

export default veeValidatePlugin
